/**
 * GOaktiv Rabattcode-Leiste
 * Zeigt oben auf der Seite „Code XYZ erfolgreich aktiviert", sobald ein Rabattcode
 * per Link aktiviert wurde. Kein Backend, keine App, keine Abfrage für Besucher ohne Code.
 *
 * Woher der Code kommt:
 *   1. ?discount=CODE in der Adresse   (Warenkorb-Links  /cart/123:1?discount=CODE)
 *   2. Cookie "discount_code"          (Rabatt-Links     /discount/CODE – setzt Shopify selbst)
 *   3. sessionStorage                  (merkt sich Quelle 1 für die Folgeseiten)
 *
 * Geprüft wird nur, wenn schon etwas im Warenkorb liegt: Dann fragt das Script einmal
 * /cart.js ab und zeigt die Leiste nur, wenn Shopify den Code dort als gültig führt.
 */
(function () {
  'use strict';

  // ---- Konfiguration ----
  var EXCLUDED = [];                    // Codes ohne Leiste, z. B. ['INTERN', 'MITARBEITER']
  var TEXT = 'erfolgreich aktiviert';
  var HINT = '– wird im Warenkorb automatisch abgezogen';   // nur ab Tablet-Breite sichtbar
  var BG = '#2BA9BE';                   // GOaktiv-Türkis (wie die Leiste im alten Theme)
  var FG = '#002C4D';                   // GOaktiv-Blau – auf Türkis besser lesbar als Weiß
  var CHIP = '#002C4D';                 // Hintergrund des Code-Kürzels (Schrift weiß)
  var AUTO_HIDE = 5;                    // Sekunden, bis die Leiste von selbst verschwindet (0 = bleibt stehen)
  var KEY = 'ga_discount';

  var store = {
    get: function (k) { try { return sessionStorage.getItem(k) || ''; } catch (e) { return ''; } },
    set: function (k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  };

  function cookie(name) {
    var m = document.cookie.match('(?:^|; )' + name + '=([^;]*)');
    try { return m ? decodeURIComponent(m[1]) : ''; } catch (e) { return ''; }
  }

  // ---- Code ermitteln ----
  var fromUrl = new URLSearchParams(location.search).get('discount') || '';
  if (fromUrl) store.set(KEY, fromUrl);
  var code = (fromUrl || cookie('discount_code') || store.get(KEY)).trim().slice(0, 64);
  if (!code) return;

  var upper = code.toUpperCase();
  if (EXCLUDED.indexOf(upper) !== -1) return;
  if (store.get(KEY + '_closed') === upper) return;

  // ---- Leiste bauen ----
  function render() {
    if (document.getElementById('ga-discount-bar')) return;

    var style = document.createElement('style');
    style.textContent =
      '#ga-discount-bar{background:' + BG + ';color:' + FG + ';display:flex;align-items:center;' +
        'justify-content:center;gap:8px;padding:10px 44px;font-size:14px;font-weight:600;line-height:1.4;' +
        'text-align:center;position:relative;z-index:10;overflow:hidden;animation:gaBar .3s ease;' +
        'transition:height .3s ease,padding .3s ease,opacity .3s ease}' +
      '#ga-discount-bar svg{width:16px;height:16px;flex:none}' +
      '#ga-discount-bar code{font:inherit;font-weight:700;letter-spacing:.03em;background:' + CHIP + ';' +
        'color:#fff;padding:1px 7px;border-radius:3px;white-space:nowrap}' +
      '#ga-discount-bar button{position:absolute;right:0;top:0;height:100%;width:44px;background:none;' +
        'border:0;color:inherit;font-size:20px;line-height:1;cursor:pointer;opacity:.7}' +
      '#ga-discount-bar button:hover{opacity:1}' +
      '#ga-discount-bar i{font-style:normal;opacity:.85}' +
      '@keyframes gaBar{from{opacity:0;transform:translateY(-100%)}to{opacity:1;transform:none}}' +
      '@media (max-width:749px){#ga-discount-bar i{display:none}}' +
      '@media (prefers-reduced-motion:reduce){#ga-discount-bar{animation:none;transition:none}}';
    document.head.appendChild(style);

    var bar = document.createElement('div');
    bar.id = 'ga-discount-bar';
    bar.setAttribute('role', 'status');
    bar.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true"><polygon fill="currentColor" ' +
      'points="9,20 2,13 5,10 9,14 19,4 22,7"/></svg>' +
      '<span>Code <code></code> ' + TEXT + ' <i>' + HINT + '</i></span>' +
      '<button type="button" aria-label="Hinweis schließen">×</button>';
    bar.querySelector('code').textContent = code;        // textContent → keine HTML-Injection
    bar.querySelector('button').addEventListener('click', function () {
      bar.remove();
      store.set(KEY + '_closed', upper);
    });

    document.body.insertBefore(bar, document.body.firstChild);

    // Nach AUTO_HIDE Sekunden sanft einklappen (ohne Sprung im Layout), dann entfernen.
    // Gilt nur für diese Seite – auf der nächsten Seite erscheint die Leiste wieder.
    if (AUTO_HIDE > 0) {
      setTimeout(function () {
        bar.style.height = bar.offsetHeight + 'px';
        bar.offsetHeight;                                  // Ausgangshöhe festschreiben
        bar.style.height = '0';
        bar.style.paddingTop = bar.style.paddingBottom = '0';
        bar.style.opacity = '0';
        setTimeout(function () { bar.remove(); }, 350);
      }, AUTO_HIDE * 1000);
    }
  }

  // ---- Prüfen (nur bei gefülltem Warenkorb) und anzeigen ----
  function start() {
    var hasItems = document.documentElement.classList.contains('cart-has-items') ||
      /^\/cart(\/|$)/.test(location.pathname);
    if (!hasItems) return render();

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.item_count) return render();
        var valid = (cart.discount_codes || []).some(function (d) {
          return d.applicable && String(d.code).toUpperCase() === upper;
        });
        if (valid) render();
      })
      .catch(function () {});
  }

  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start);
})();
